module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_6005.cb17b63c.png";